// Hybrid 路由配置
export default {
  member: '/guild/member', // 公会成员列表
  apply: '/guild/apply', // 公会申请列表
  list: '/guild/list', // 公会列表
  recharge: '/recharge', // 充值
  agentLogin: '/agent/login', // 代理登陆
  agentCoin: '/agent/coin', // 代理分发金币
}



// WEBPACK FOOTER //
// src/core/hybrid-router.js